import React from 'react';
import { Flex, Text } from '@spothero/ui';
export const DriverTagChip = ({ emoji, label, count }) => {
    return (<Flex alignItems="center" gap={1} paddingX={3} paddingY={1} bg="gray.50" borderRadius="lg" fontSize="sm" data-testid="DriverTagChip">
            <span>{emoji}</span>
            <Text fontSize="xs">{label}</Text>
            <Text fontSize="xs" color="gray.600">
                {count}
            </Text>
        </Flex>);
};
